export const DEFAULT_FETCHED_DATA_TTL = 3;
export const DEFAULT_RATE_LIMIT_TTL = 5;
export const COMMENT_LIKE_RATE_LIMIT_TTL = 1;
